import { Button } from "../../Button/Button/Button";
import { FlagIcon } from "../../Icon/FlagIcon/FlagIcon";
import { Text } from "../../Text/Text/Text";
import styles from "./FlagCountryNameBlock.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FlagCountryNameBlock = function FlagCountryNameBlock(_ref) {
  var countryCode = _ref.countryCode,
    countryLink = _ref.countryLink,
    countryName = _ref.countryName,
    _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
    title = _ref.title;
  return /*#__PURE__*/_jsx("div", {
    className: styles.country,
    children: /*#__PURE__*/_jsxs(Button, {
      url: countryLink,
      type: "no-style",
      className: styles.countryLink,
      "data-e2e-name": "country_flag_button",
      accessibilityLabel: title,
      attributes: attributes,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.countryFlag,
        children: /*#__PURE__*/_jsx(FlagIcon, {
          countryCode: countryCode,
          label: countryName
        })
      }), /*#__PURE__*/_jsx(Text, {
        "data-e2e-name": "country_flag_text",
        className: styles.countryText,
        typog: "bodycopySmall",
        children: countryName
      })]
    })
  });
};